var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailRedeem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 19.1406C24.5312 18.6719 25.3906 18.6719 25.8594 19.1406C26.3281 19.6094 26.3281 20.4688 25.8594 20.9375L21.7188 25L25.8594 29.1406C26.3281 29.6094 26.3281 30.4688 25.8594 30.9375C25.3906 31.4062 24.5312 31.4062 24.0625 30.9375L20 26.7969L15.8594 30.9375C15.3906 31.4062 14.5312 31.4062 14.0625 30.9375C13.5938 30.4688 13.5938 29.6094 14.0625 29.1406L18.2031 25L14.0625 20.9375C13.5938 20.4688 13.5938 19.6094 14.0625 19.1406C14.5312 18.6719 15.3906 18.6719 15.8594 19.1406L20 23.2812L24.0625 19.1406ZM0 32.5C0 21.4062 7.10938 14.375 11.875 10.8594C12.6562 10.3125 13.3594 9.84375 13.9844 9.45312L9.45312 2.96875C8.59375 1.71875 9.53125 0 11.0156 0H28.9062C30.3906 0 31.3281 1.71875 30.4688 2.96875L25.9375 9.45312C26.5625 9.84375 27.2656 10.3125 28.0469 10.8594C32.8125 14.375 40 21.4062 40 32.5C40 36.6406 36.6406 40 32.5 40H7.5C3.28125 40 0 36.6406 0 32.5ZM24.2188 11.25H15.7031L15.3125 11.5625C11.0156 14.2969 2.5 21.0156 2.5 32.5C2.5 35.3125 4.6875 37.5 7.5 37.5H32.5C35.2344 37.5 37.5 35.3125 37.5 32.5C37.5 21.0156 28.9062 14.2969 24.6094 11.5625L24.2188 11.25ZM27.7344 2.5H12.1875L16.5625 8.75H23.3594L27.7344 2.5Z",
    fill: "#E46666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailRedeem);
export default __webpack_public_path__ + "static/media/fail-redeem.4c6fcbe3419a3cc909ed794301e4e2f3.svg";
export { ForwardRef as ReactComponent };